export function isMobileInputMode(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(max-width: 768px), (pointer: coarse)').matches;
}

export function shouldSkipAutoComposerFocus(): boolean {
  return isMobileInputMode();
}

export function focusComposerElement(
  input: HTMLInputElement | HTMLTextAreaElement | null | undefined,
  options?: FocusOptions,
): boolean {
  if (!input || input.disabled || shouldSkipAutoComposerFocus()) return false;
  input.focus(options);
  return true;
}
